import { z } from "zod";

export const acceptInviteSchema = z
	.object({
		name: z.string().min(1, { message: "Nome é obrigatório" }),
		password: z
			.string()
			.min(8, { message: "A senha precisa de ao menos 8 caracteres" }),
		passwordConfirm: z.string().min(1, { message: "Confirme a senha" }),
	})
	.refine((data) => data.password === data.passwordConfirm, {
		message: "As senhas não conferem",
		path: ["passwordConfirm"],
	});

export type AcceptInviteFormValues = z.infer<typeof acceptInviteSchema>;

export const joinInviteSchema = z.object({
	name: z.string(),
	password: z.string().min(1, { message: "Informe a senha da sua conta" }),
	passwordConfirm: z.string(),
});
